import React from 'react';
import './AddCategory.scss';
import Icon from '../Icon';
import MusicIcon from './MusicIcon';
import PodcastIcon from './PodcastIcon';

export const categoriesProps = [
    // { icon: 'library-music', title: 'Music', color: "none", stroke: "#000", value: "music", activeColor: "none", activeStroke: "#FF3232"    },
    { icon: 'library-artwork', title: 'Artwork', color: "#000", value: "artwork", activeColor: "#FF3232" },
    { icon: 'library-music',title: 'Music', value: 'music', iconComp: <MusicIcon width={56} color="#000" />, activeIconComp: <MusicIcon width={56} color="#FF3232" /> },
    // { icon: 'library-podcast', title: 'Podcast', color: "#ffffff", stroke: "#000", value: "podcast", activeColor: "none", activeStroke: "#FF3232" },
    { icon: 'library-photography', title: 'Photography', color: "#000", value: "photography", activeColor: "#FF3232" },
    { icon: 'library-video', title: 'Film', color: "#000", value: "video", activeColor: "#FF3232" },
    { icon: 'library-podcast', title: 'Podcast', value: 'podcast', iconComp: <PodcastIcon width={56} color="#000" />, activeIconComp: <PodcastIcon width={56} color="#FF3232" /> },
    { icon: 'library-book', title: 'Book', color: "#000", value: "book", activeColor: "#FF3232" },
    { icon: 'library-clothing', title: 'Clothing', color: "#000", value: "clothing", activeColor: "#FF3232" },
    {
        icon: 'library-handmade', title: 'Craft', color: "#000", value: "handmade_craft", activeColor: "#FF3232"
    },
];

const AddCategory = ({ onClick, selectedCategory }) => {

    const handleCategoryClick = (category) => {
        onClick(category)
    }

    return (
        <div className="categoriesSection">
            <div className="categoriesGrid">
                {categoriesProps.map((cat, idx) => (
                    <div onClick={() => handleCategoryClick(cat.value)} className="categoryCard" key={idx}>
                        <div className="categoryIcon">
                            {cat.iconComp ?
                                (selectedCategory === cat.value ? cat.activeIconComp : cat.iconComp) :
                                <Icon alias={cat.icon} color={selectedCategory === cat.value ? cat.activeColor : cat.color} stroke={selectedCategory === cat.value ? cat.activeStroke : cat.stroke} width={48} />
                            }
                        </div>
                        <span className={`categoryLabel fw-bold fs-real ${selectedCategory === cat.value ? 'fg-red' : ''}    `}>{cat.title}</span>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default AddCategory; 